import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import ListCustomView from "../views/ListCustomView.vue";
import EventCustomView from "../views/EventCustomView.vue";
import ArticleCustomView from "../views/ArticleCustomView.vue";
import ContactView from "../views/ContactView.vue";
import ContactResponseView from "../views/ContactResponseView.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
import UnderConstructionView from "../views/UnderConstructionView.vue";
import AboutCustomView from "../views/AboutCustomView.vue";
import MagazineItemView from "../views/MagazineItemView.vue";
import MagazineListView from "../views/MagazineListView.vue";
import EventCard from "../components/cards/EventCard.vue";
import NewsCard from "../components/cards/NewsCard.vue";
import TeamCard from "../components/cards/TeamCard.vue";
import MagazineCard from "../components/cards/MagazineCard.vue";
import Error404View from "../views/Error404View.vue";

Vue.use(VueRouter);

const routes = [
  {
    name: "",
    path: "/",
    component: HomeView,
  },
  {
    name: "Perfil",
    path: "/perfil",
    component: AboutCustomView,
    meta: {
      mod: "profile",
      title: (component) => component.$rest("profile").item.title,
    },
  },
  {
    name: "História",
    path: "/historia",
    component: AboutCustomView,
    meta: {
      mod: "history",
      title: (component) => component.$rest("history").item.title,
    },
  },
  {
    name: "Equipe",
    path: "/equipe",
    component: ListCustomView,
    meta: {
      mod: "team",
      cardComponent: TeamCard,
      cols: { xs: 1, sm: 1, md: 2, lg: 2, xl: 2 },
    },
  },
  {
    name: "Coberturas",
    path: "/coberturas",
    component: ListCustomView,
    meta: {
      mod: "events",
      cardComponent: EventCard,
    },
  },
  {
    name: "Coberturas",
    path: "/coberturas/:item",
    component: EventCustomView,
    meta: {
      mod: "events",
    },
  },
  {
    name: "Busca",
    path: "/busca",
    component: ListCustomView,
    meta: {
      mod: "events",
      cardComponent: EventCard,
      params: (component) => ({
        search: component.$route.query.q,
      }),
      basePath: "/coberturas",
    },
  },
  {
    name: "Almanaque",
    path: "/almanaque",
    component: MagazineListView,
  },
  {
    name: "Almanaque",
    path: "/almanaque/:item",
    component: MagazineItemView,
  },
  {
    name: "Almanaque",
    path: "/almanaque",
    component: ListCustomView,
    meta: {
      mod: "magazines",
      cardComponent: MagazineCard,
      cols: { xs: 2, sm: 3, md: 4, lg: 5, xl: 5 },
    },
  },
  {
    name: "Blog",
    path: "/blog",
    component: ListCustomView,
    meta: {
      mod: "news",
      cardComponent: NewsCard,
      cols: { xs: 2, sm: 2, md: 4, lg: 5, xl: 5 },
    },
  },
  {
    name: "Notícia",
    path: "/blog/:item",
    component: ArticleCustomView,
    meta: {
      mod: "news",
    },
  },
  {
    name: "Contato",
    path: "/contato",
    component: ContactView,
  },
  {
    name: "Obrigado!",
    path: "/contato/obrigado",
    component: ContactResponseView,
  },
  {
    name: "FeijoVip",
    path: "/feijovip",
    component: UnderConstructionView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "/:item",
    name: "Coberturas",
    component: ListCustomView,
    meta: {
      mod: "events",
      title(component) {
        const category = component
          .$rest("events-categories")
          .list.find((v) => v.slug == component.$route.params.item);

        if (category) {
          return category.title;
        } else {
          return component.$route.name;
        }
      },
      basePath: "/coberturas",
      cardComponent: EventCard,
      params: (component) => {
        const category = component
          .$rest("events-categories")
          .list.find((v) => v.slug == component.$route.params.item);

        return {
          category: category.id,
        };
      },
    },
  },
  {
    path: "*",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
